<template>
  <IziCard class="card-leaderboard">
    <IziGrid>
      <IziCol class="title">
        <h4>{{ title }}</h4>
      </IziCol>
      <IziCol class="action-filter">
        <TabView>
          <TabPanel header="All TIME">
            <PlayerRankings :ranks="ranks" />
          </TabPanel>
          <TabPanel header="THIS WEEK">
            <PlayerRankings :ranks="ranks" />
          </TabPanel>
        </TabView>
      </IziCol>
    </IziGrid>
  </IziCard>
</template>
<script lang="ts">
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { interval } from "rxjs/internal/observable/interval";
import { map } from "rxjs/operators";
import { computed } from "vue";
import { Options } from "vue-class-component";
import Base from "./../base/Base.vue";
@Options({
  props: ["title"]
})
export default class Leaderboard extends Base {
  title!: string;
  selected = "";

  public selectedGame = null;
  public subPlayer = new BehaviorSubject<any>([]);
  public top10Player = this.subPlayer.asObservable();

  public currentGame: any = computed(() => this.store.getters.getGameSelected);
  public ranks = computed(() =>
    this.usersPlayGame
      .sort((a, b) => b.score - a.score)
      .slice(0, 6)
      .map(p => p)
  );

  public dataStream = [];

  created() {
    this.fakeUpScore();
    this.scoreTrack().subscribe();
    this.top10Player.subscribe(player => {
      this.dataStream = player;
    });
  }

  scoreTrack() {
    return interval(1000).pipe(
      map(() => {
        this.subPlayer.next(this.usersPlayGame);
      })
    );
  }

  fakeUpScore() {
    setInterval(() => {
      const indexUser = Math.floor(Math.random() * 15);
      const score = Math.floor(Math.random() * 10) + 1;
      this.usersPlayGame[indexUser].score += score;
    }, 1000);
  }

  public usersPlayGame = [
    {
      userId: 1,
      avatarUrl:
        "https://lh3.googleusercontent.com/proxy/3akPGAIzEvunv1Av3r6leheyR4Sk0Z2e8Uah92qJXGd_jq8H27NIJOWMHzm-eYCfmCVJwKWZVUcRPA8uZvtL7KS3e9HLNOM-ppBeEunBFSHK5ahBcJ3kxtKq",
      name: "Aatrox",
      score: 1,
      status: "online"
    },
    {
      userId: 2,
      avatarUrl:
        "https://i.pinimg.com/736x/4e/1b/03/4e1b0315461c472c24a7505632e68a81.jpg",
      name: "Ahri",
      score: 3,
      status: "offline"
    },
    {
      userId: 3,
      avatarUrl:
        "https://i.pinimg.com/originals/58/d9/af/58d9af3f6bae76b6b0e57c5ba63fa94d.png",
      name: "Akali",
      score: 2,
      status: "offline"
    },
    {
      userId: 4,
      avatarUrl:
        "https://lh3.googleusercontent.com/proxy/inMs1Gh8XytzdQNExWP5Wq9TMcw51uLT0CuoS16rIOXPePGWKuKoij84VZcjmzTgOI8zj0AX19et_BkDefKXaj8FsD50ebAvVELKS9nyuPW-h-fHCL07Vhloxg",
      name: "Alistar",
      score: 1,
      status: "offline"
    },
    {
      userId: 5,
      avatarUrl:
        "https://i.pinimg.com/originals/4b/a2/32/4ba23257a87134cc7cc495b97d94583c.jpg",
      name: "Amumu",
      score: 5,
      status: "offline"
    },
    {
      userId: 6,
      avatarUrl:
        "https://st.quantrimang.com/photos/image/2019/09/05/Tuong-5-Vang-DTCL-1.jpg",
      name: "Anivia",
      score: 5,
      status: "offline"
    },
    {
      userId: 7,
      avatarUrl: "https://avatarfiles.alphacoders.com/123/thumb-123905.jpg",
      name: "Annie",
      score: 7,
      status: "offline"
    },
    {
      userId: 8,
      avatarUrl:
        "https://i.pinimg.com/originals/9a/61/d8/9a61d87bfd632d6984a926a675f1efc0.jpg",
      name: "Aphelios",
      score: 0,
      status: "offline"
    },
    {
      userId: 9,
      avatarUrl:
        "https://steamuserimages-a.akamaihd.net/ugc/784112627473769251/B5CCE7A7EAA7AC6AF5DEE41885FA901C74B825FB/?imw=512&&ima=fit&impolicy=Letterbox&imcolor=%23000000&letterbox=false",
      name: "Ashe",
      score: 9,
      status: "offline"
    },
    {
      userId: 10,
      avatarUrl:
        "https://i.pinimg.com/originals/39/de/2b/39de2b9e40f8213bcae596ae000b59dd.jpg",
      name: "Aurelion Sol",
      score: 1,
      status: "offline"
    },
    {
      userId: 11,
      avatarUrl: "https://avatarfiles.alphacoders.com/236/thumb-236565.jpg",
      name: "Yasuo",
      score: 0,
      status: "offline"
    },
    {
      userId: 12,
      avatarUrl:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcST5CrBy0Mq5T3hmFRxpdhCaYxihsqUmTxtEZppbDTgbkcbkEVQ-8TcBCCkR18KB6HJLj1ijH39sP51SQcoYDE15BC2df1ofZMF9IDL7f8&usqp=CAU&ec=45725303",
      name: "Master Yi",
      score: 2,
      status: "offline"
    },
    {
      userId: 13,
      avatarUrl: "https://avatarfiles.alphacoders.com/147/thumb-147136.jpg",
      name: "Fiora",
      score: 7,
      status: "offline"
    },
    {
      userId: 14,
      avatarUrl:
        "https://i.pinimg.com/474x/62/15/2b/62152b4598b69c68e8f4c01e5d857b0a.jpg",
      name: "Gnar",
      score: 9,
      status: "online"
    },
    {
      userId: 15,
      avatarUrl:
        "https://lh3.googleusercontent.com/proxy/hc52y5hbyUqHqxDUkAyDIwFgePFobQVXHDr_04FYjf6Nj_9dikOmjs90i-TFhxPPCjc17_5C9DQ0zaW9ZcXXE8Cf-BgX_cLFebGhbaNS_6l2WpFNhH_Kvfj1aUo",
      name: "Rengar",
      score: 0,
      status: "offline"
    }
  ];
}
</script>
<style lang="scss">
.card-leaderboard {
  .title {
    font-weight: bold;
    text-align: center;
    font-size: 15px;
  }
  .p-selectbutton .p-button.p-highlight {
    background: transparent;
    border-color: transparent;
    color: transparent;
  }
  .action-filter {
    text-align: center;
    padding: 0px;
    .p-tabview-title {
      font-weight: bold;
      color: $primary-color;
    }
    .p-tabview .p-tabview-panels {
      padding: 0px;
    }
    .p-tabview .p-tabview-nav .p-tabview-ink-bar {
      background-color: $border-input;
    }
    .player-rankins.top-3 {
      background: $primary-background;
      font-size: 18px;
    }
  }

  .p-button-label {
    color: $primary-color;
  }
  .p-button-text::selection {
    border-bottom: solid 1px red;
  }
  .p-tabview .p-tabview-panels {
    padding: 0.5em;
  }
  .p-tabview .p-tabview-nav {
    justify-content: center;
  }
}
</style>
